var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-to-top",class:{ 'show': _vm.isVisible },on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fa fa-arrow-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }